"use client";
import { FunctionComponent } from "react";
import BulletPointParagraph from "../../BulletPointParagraph";
import { useTranslationBulletPoints } from "./bulletPoints.hooks";
import { scrollFx } from "@/modules/visual/scrollFx";

interface BulletPointsSectionHomeProps {}

const BulletPointsSectionHome: FunctionComponent<
  BulletPointsSectionHomeProps
> = () => {
  const {
    bulletsPointParaphraphe1TitleTranslation,
    bulletsPointParaphraphe1TextTranslation,
    bulletsPointParaphraphe2TitleTranslation,
    bulletsPointParaphraphe2TextTranslation,
    bulletsPointParaphraphe3TitleTranslation,
    bulletsPointParaphraphe3TextTranslation,
    bulletsPointParaphraphe1BTextTranslation,
    bulletsPointParaphraphe1BTitleTranslation,
    bulletsPointParaphraphe2bTextTranslation,
    bulletsPointParaphraphe2bTitleTranslation,
    bulletsPointParaphraphe3bTextTranslation,
    bulletsPointParaphraphe3bTitleTranslation,
    bulletPointsTitle,
  } = useTranslationBulletPoints();

  return (
    <section
      className="py-8 md:py-16"
      {...scrollFx({ trigger: "enter", effect: "slide", from: "left" })}
    >
      <div className="max-w-[80%] mx-auto my-4 text-center">
        <h2 className="text-4xl">{bulletPointsTitle}</h2>
      </div>

      <div className="max-w-[80%] mx-auto flex items-center flex-col md:!flex-row">
        <BulletPointParagraph
          text={bulletsPointParaphraphe1BTextTranslation}
          title={bulletsPointParaphraphe1BTitleTranslation}
        />
        <BulletPointParagraph
          text={bulletsPointParaphraphe2bTextTranslation}
          title={bulletsPointParaphraphe2bTitleTranslation}
        />
        <BulletPointParagraph
          text={bulletsPointParaphraphe3bTextTranslation}
          title={bulletsPointParaphraphe3bTitleTranslation}
        />
      </div>
    </section>
  );
};

export default BulletPointsSectionHome;
